//Librerias
import styled from 'styled-components'
import { useState } from 'react'
import { login } from '../api/login';
import { ToastContainer, toast } from 'react-toastify';
import logo from '../res/login/prueba.png'
import logo_white from '../res/login/white_logo1.png'
import { ArrowRight, Eye, EyeOff, LockKeyhole, Mail } from 'lucide-react'

function Login() {

  const [showPassword, setShowPassword] = useState(false);

  return (
    <Container>
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        closeOnClick={false}
        rtl={false}
        theme="light"
      />
      <BigLogo>
        <img src={logo_white} alt="Logo" />
      </BigLogo>
      <Layout>
        
        <div className='energy-orbit one'>
          <div className='energy-orbit two'>
            <div className='ring'>
              <img className='energy-logo' src={logo} alt="Logo" />
            </div>
          </div>
        </div>
        
        <Footer>COLTON COBI / PORTAL DE MONITOREO</Footer>
      </Layout>
      
      <LoginForm>
        
        <form id="log_in" className="log-in" onSubmit={sendLogin}>
          <h2>Iniciar Sesión</h2>
          <InputWrapper>
            <p>Correo electrónico</p>
            <MailIcon>
              <Mail/>
            </MailIcon>

            <Input
              id="email"
              type="email"
              autoComplete="email"
              placeholder="nombre@empresa.com"
            />
          </InputWrapper>
          <InputWrapper>
            <p>Contraseña</p>
            <MailIcon>
              <LockKeyhole/>
            </MailIcon>

            <Input
              id="password"
              type={showPassword ? "text" : "password"}
              autoComplete="password"
              placeholder="********"
            />
            <VisibilityButton
              type="button"
              onClick={() => setShowPassword(prev => !prev)}
              aria-label={
                showPassword
                  ? "Ocultar contraseña"
                  : "Mostrar contraseña"
              }
            >
                {showPassword ? <EyeOff /> : <Eye />}
            </VisibilityButton>
          </InputWrapper>
          
          <Submit type="submit">Iniciar sesión <ArrowRight/></Submit>
        </form>
      </LoginForm>
      <Safe>
        <div className='circle'/>
        CONEXIÓN SEGURA
      </Safe>
      <Grid/>
    </Container>
  )
}



async function sendLogin(e) {
  e.preventDefault();

  const form = e.target;
  const button = form.querySelector("button");
  button.disabled = true;
  button.classList.add("loading");
  const email = form.email.value;
  const password = form.password.value;;

  const loginPromise = login(email, password);

  try {
    const response = await toast.promise(loginPromise, {
      pending: "Iniciando sesión...",
      success: {
        render: "Inicio exitoso",
        autoClose: 2000
      },
      error: {
        render: ({ data }) => data.message || "Error",
        autoClose: 5000
      }
    });

    if(response.error !== false){
      throw new Error(response.message || "Error al iniciar sesión");
    }
    const userData = {
      token : response.body.token,
      id : response.body.id
    }
    localStorage.setItem("user", JSON.stringify(userData));
    window.location.href = "./home";
    

  } catch (err) {
    console.error(err);
    button.disabled = false;
    button.classList.remove("loading");
  }
}

const Footer = styled.div`
  position: absolute;
  z-index: 4;
  bottom: 2%;
  left: 2%;
  color: #FFFFFF60;
`

const BigLogo = styled.div`
  position: absolute;
  z-index: 4;
  top: 3%;
  left: 1.5%;
`

const Submit = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: none;
  background: #2859a2;
  color: #fff;
  width: 100%;
  height: 48px;
  font-size: 1rem;
  gap: 10px;
  border-radius: 10px;
  transition: transform 0.3s ease, gap 0.3s ease, box-shadow 0.3s ease;

  &:hover{
    cursor: pointer;
    transform: translateY(-5%);
    gap: 15px;
    box-shadow: 0 8px 24px -10px #2859a2;
  }
`

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Input = styled.input`
  box-sizing: border-box;

  width: 100%;
  height: 48px;

  padding: 0 16px 0 44px;

  border: 1px solid #d9dee7;
  border-radius: 12px;

  background: #ffffff;

  font-size: 14px;
  color: #1f2937;

  outline: none;

  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    background-color 150ms ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.10);
  }
`;

const MailIcon = styled.svg`
    position: absolute;

    left: 14px;
    top: 63%;

    width: 24px;
    height: 24px;

    transform: translateY(-50%);

    pointer-events: none;

    color: #9ca3af;
`;

const VisibilityButton = styled.button`
    position: absolute;

    right: 8px;
    top: 65.5%;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 32px;
    height: 32px;

    transform: translateY(-50%);

    border: none;
    border-radius: 8px;

    background: transparent;
    color: #9ca3af;

    cursor: pointer;

    transition:
        background-color 0.15s ease,
        color 0.15s ease;

    &:hover {
        background: #f3f4f6;
        color: #1f2937;
    }

    &:focus {
        outline: none;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

const Layout = styled.div`
  width: 54%;
  height: 100%;
  background: #2859a2;
  z-index: 2;

  .energy-orbit{
    border: 1px solid #ffffff40;
    border-radius: 999px;
    position: absolute;
    transform: rotate(-28deg);
  }

  .ring{
    display: grid;
    place-items: center;
    top: 44%;
    left: 29%;
    margin-left: 3%;
    width: 190px;
    height: 190px;
    border-radius: 50%;
    border: 1px solid #fff;
    background: #FFFFFF20;
    transform: rotate(28deg);
  }

  .energy-logo{
    width: auto;
    height: 140px;
  }
  .one{
    width: 750px;
    height: 260px;
    display: flex;
    align-items: center;
    top: 24.5%;
    left: 24.5%;
  }

  .two{
    width: 680px;
    height: 220px;
    display: flex;
    align-items: center;
    margin-left: 2%;
    transform: rotate(0deg);
  }
`

const Safe = styled.div`
  position: absolute;
  z-index: 4;
  bottom: 8%;
  right: 18%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #00000060;
  
  font-size: .75rem;
  .circle{
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #2859a2;
  }
`

const LoginForm = styled.div`
  width: 46%;
  height: 100%; 
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  form{
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 390px;
  }

  form p{
    font-size: .80rem;
    padding-bottom: 8px;
  }
`

const Grid = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.22;
  background-image:
    linear-gradient(to right, rgba(0, 0, 0, 0.18) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.18) 1px, transparent 1px);
  background-size: 42px 42px;
`



const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f4f7fb;
`
export default Login